(function($){
    $('.remove-dictionary-element').on('click', function(e){
        e.preventDefault();
        if (confirm($(this).attr('data-confirm'))) {
            remove_dictionary_element($(this).attr('data-type'), $(this).attr('data-pid'), $(this).attr('data-name'));
        }
    })
})(jQuery);